import SignIn from '$modules/onboarding/module-components/sign-in';
const SignInWeb = () => {
  return <SignIn data-sentry-element="SignIn" data-sentry-component="SignInWeb" data-sentry-source-file="signIn.web.tsx" />;
};
export default SignInWeb;